export const MANUAL_PERIODS_HEADER =
  'Períodos registrados manualmente — sem aprovação no sistema';

export const MANUAL_PERIODS_EMPTY = 'Nenhum período registrado.';

export const HISTORY_EMPTY = 'Nenhum histórico de solicitações.';

export const HISTORY_SECTION_TITLE = 'Histórico de Solicitações';

export const MANUAL_SECTION_TITLE = 'Lançamentos Manuais';
